// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .LoginForm_formContainer__kh35A {
    background-color: white;
    background-repeat: no-repeat;
    background-position: bottom;
    padding: 6% 0;
  }
  @media (max-width: 767px) {
    .LoginForm_formContainer__kh35A {
      padding: 0 5%;
    }
  }
  .LoginForm_headerTitle__zWoW7 {
    margin: 15px 0 20px 0;
    color: #3F4C52 !important;
    font-family: "DM Serif Display";
    font-weight: 700;
    font-size: 2.5em;
    white-space: nowrap;
    text-align: center;
  }
  .LoginForm_input__AKW9e {
    width: 100%;
    padding: 0.5rem;
    margin: 0.1em;
    text-overflow: ellipsis;
    border: 2px solid #ccc;
    border-radius: 50em !important;
    font-size: 100%;
    transition: border-color 0.3s;
    color: inherit;
    font-family: inherit;
    line-height: inherit;
  
  }
  
  .LoginForm_input__AKW9e:focus {
    outline: none;
    border-color: #D4AA41 !important;
    box-shadow: 0 0 5px rgba(212, 170, 65, 0.5) !important;
  }
  
  .LoginForm_buttonStyle__hF\\+cS {
    max-width: 100%;
    border-radius: 50em !important;
    border-color: #4AAE9B ;
    padding: 0.5rem 0.5rem;
    font-size: 1em !important;
    font-weight: 600;
    background-color: #4AAE9B !important; 
    color: #fff !important;
    transition: background-color 0.3s;
  }
  
  .LoginForm_horizontalBarContainer__KFoIk {
    display: flex;
    align-items: center;
    margin-bottom: 20px; 
  }
  
  .LoginForm_horizontalBar__nxm-J {
    flex-grow: 1;
    height: 2px;
    background-color: #000;
    margin: 0 10px;
  }
  
  .LoginForm_inputWithIcon__-eUCD {
    position: relative;
  }
  
  .LoginForm_icon__6oOIh {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Login/LoginForm.module.css"],"names":[],"mappings":"EAAE;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,oBAAoB;IACpB,oBAAoB;;EAEtB;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,sDAAsD;EACxD;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,oCAAoC;IACpC,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;EACtB","sourcesContent":["  .formContainer {\n    background-color: white;\n    background-repeat: no-repeat;\n    background-position: bottom;\n    padding: 6% 0;\n  }\n  @media (max-width: 767px) {\n    .formContainer {\n      padding: 0 5%;\n    }\n  }\n  .headerTitle {\n    margin: 15px 0 20px 0;\n    color: #3F4C52 !important;\n    font-family: \"DM Serif Display\";\n    font-weight: 700;\n    font-size: 2.5em;\n    white-space: nowrap;\n    text-align: center;\n  }\n  .input {\n    width: 100%;\n    padding: 0.5rem;\n    margin: 0.1em;\n    text-overflow: ellipsis;\n    border: 2px solid #ccc;\n    border-radius: 50em !important;\n    font-size: 100%;\n    transition: border-color 0.3s;\n    color: inherit;\n    font-family: inherit;\n    line-height: inherit;\n  \n  }\n  \n  .input:focus {\n    outline: none;\n    border-color: #D4AA41 !important;\n    box-shadow: 0 0 5px rgba(212, 170, 65, 0.5) !important;\n  }\n  \n  .buttonStyle {\n    max-width: 100%;\n    border-radius: 50em !important;\n    border-color: #4AAE9B ;\n    padding: 0.5rem 0.5rem;\n    font-size: 1em !important;\n    font-weight: 600;\n    background-color: #4AAE9B !important; \n    color: #fff !important;\n    transition: background-color 0.3s;\n  }\n  \n  .horizontalBarContainer {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px; \n  }\n  \n  .horizontalBar {\n    flex-grow: 1;\n    height: 2px;\n    background-color: #000;\n    margin: 0 10px;\n  }\n  \n  .inputWithIcon {\n    position: relative;\n  }\n  \n  .icon {\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    pointer-events: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `LoginForm_formContainer__kh35A`,
	"headerTitle": `LoginForm_headerTitle__zWoW7`,
	"input": `LoginForm_input__AKW9e`,
	"buttonStyle": `LoginForm_buttonStyle__hF+cS`,
	"horizontalBarContainer": `LoginForm_horizontalBarContainer__KFoIk`,
	"horizontalBar": `LoginForm_horizontalBar__nxm-J`,
	"inputWithIcon": `LoginForm_inputWithIcon__-eUCD`,
	"icon": `LoginForm_icon__6oOIh`
};
export default ___CSS_LOADER_EXPORT___;
